/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan';
import { ScheduleMode } from '../models/ScheduleMode';

export class UpdateDlsgPolicyRequest {
  /**
  * DLSG policy display name.
  */
  'name': string;
  /**
  * List of cloud-provider-assigned resource IDs to include in the dlsg policy. 
  */
  'resourceInclusion': Array<string>;
  'policyPlan': DlsgPolicyPlan;
  'scheduleMode'?: ScheduleMode;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceInclusion",
      "baseName": "resourceInclusion",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "policyPlan",
      "baseName": "policyPlan",
      "type": "DlsgPolicyPlan",
      "format": ""
    },
    {
      "name": "scheduleMode",
      "baseName": "scheduleMode",
      "type": "ScheduleMode",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateDlsgPolicyRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



